import { Action } from '@ngrx/store';
import { ListItem } from '../../../widgets/models/list-item';

export enum PathwaySelectionsActionTypes {
  GetExecutionPath = '[Pathway Selections] Get execution path',
  UpdateExecutionPathInStore = '[Pathway Selections] Update execution path in store',
  UpdateTPNoteInStore = '[Pathway Selections] Update TP-note in store'
}

export class GetExecutionPathAction implements Action {
  readonly type = PathwaySelectionsActionTypes.GetExecutionPath;
  constructor(public payload: { }) { }
}

export interface IExecutionHistory {
  history: ListItem[];
}

export class UpdateExecutionPathInStore implements Action {
  readonly type = PathwaySelectionsActionTypes.UpdateExecutionPathInStore;
  constructor(public payload: IExecutionHistory) { }
}

export class UpdateTPNoteInStore implements Action {
  readonly type = PathwaySelectionsActionTypes.UpdateTPNoteInStore;
  constructor(public payload: string) { }
}

export type PathwaySelectionsActions = GetExecutionPathAction | UpdateExecutionPathInStore | UpdateTPNoteInStore;
